import { Bar, BarChart, CartesianGrid, XAxis } from 'recharts'
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from '~/components/ui/chart'

export type ChartDataType<TChartXAxisKey extends string, TChartYAxisKey extends string> = {
  [key in TChartXAxisKey]: string
} & { [key in TChartYAxisKey]: number }

export interface AppBarChartProps<TChartXAxisKey extends string, TChartYAxisKey extends string> {
  xAxisKey: TChartXAxisKey
  yAxisKey: TChartYAxisKey
  data: ChartDataType<TChartXAxisKey, TChartYAxisKey>[]
  xLabelFormatter?: (value: TChartXAxisKey) => string
  tooltipLabel?: string
}

export const AppBarChart = <TChartXAxisKey extends string, TChartYAxisKey extends string>({
  data,
  xAxisKey,
  yAxisKey,
  xLabelFormatter,
  tooltipLabel,
}: AppBarChartProps<TChartXAxisKey, TChartYAxisKey>) => {
  const chartConfig = {
    [yAxisKey]: {
      label: tooltipLabel,
      color: 'var(--chart-1)',
    },
  } satisfies ChartConfig

  return (
    <ChartContainer config={chartConfig}>
      <BarChart accessibilityLayer data={data}>
        <CartesianGrid vertical={false} />

        <XAxis
          dataKey={xAxisKey}
          tickLine={false}
          tickMargin={10}
          axisLine={false}
          tickFormatter={xLabelFormatter ?? ((v) => v.slice(0, 3))}
        />

        <ChartTooltip cursor={false} content={<ChartTooltipContent hideLabel />} />

        <Bar dataKey={yAxisKey} fill="var(--color-chart-1)" radius={12} />
      </BarChart>
    </ChartContainer>
  )
}
